"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_aio_helper_parseFieldName = exports.SHu_aio_underwritings_baseFields = void 0;
exports.SHu_aio_underwritings_baseFields = [
    "hs_object_id",
    "simply_object_id",
    "name",
    "hs_pipeline",
    "property_address_one_line_",
    "bedrooms",
    "estimated_cap_rate_",
    "arv",
    "number_of_units",
    "renovation_quote_accepted",
];
const SHu_aio_helper_parseFieldName = (str = "") => str.replace(/[^a-z0-9]/gi, "_").toLowerCase();
exports.SHu_aio_helper_parseFieldName = SHu_aio_helper_parseFieldName;
